export interface ActionPayload {
  text: string
  shared_with_agent?: boolean
  shared_with_client?: boolean
  shared_with_admin?: boolean
  shared_with_consumer?: boolean
}

export interface Action {
  id: string
  action_type: 'forward' | 'acknowledge'
  action_payload: ActionPayload
}

export enum WorkflowState {
  FORWARD_DRAFT = 'forward_draft',
  FORWARD_SENT = 'forward_sent',
  ACKNOWLEDGE_DRAFT = 'acknowledge_draft',
  COMPLETE = 'complete',
  DECLINED = 'declined'
}

export enum ErrorType {
  ALREADY_DECIDED = 'already_decided',
  RETRYABLE = 'retryable',
  FATAL = 'fatal'
}

export interface DraftAction extends Action {
  order_id: number
  created_at: string
  updated_at: string
  decided_at: string | null
  decision: 'approved' | 'edited' | 'declined' | null
}

export const isDraftActionDecided = (action: DraftAction): boolean => {
  return action.decision !== null
}

export const WORKFLOW_CONSTANTS = {
  TRANSITION_DELAY_MS: 2000,
  MAX_RETRY_ATTEMPTS: 3,
  SUCCESS_MESSAGE_FORWARD: 'Forward message sent!',
  SUCCESS_MESSAGE_COMPLETE: 'Message sent successfully!',
  SUCCESS_SUBTITLE_FORWARD: 'Preparing acknowledge message...',
  SUCCESS_SUBTITLE_COMPLETE: 'Refreshing page...',
  DECLINED_MESSAGE: 'Draft was declined.',
  DECLINED_SUBTITLE: 'Refreshing page...',
  ERROR_MESSAGE_ALREADY_DECIDED: 'This message is outdated.',
  ERROR_MESSAGE_RETRYABLE: 'An error occurred. Please try again.',
  ERROR_MESSAGE_FATAL: 'An error occurred. Please try creating the comment manually.'
} as const
